import { KonfiguraceZbrane as KF } from "../class/KonfiguraceZbrane.js";

export function upravStrankuKonfiguraceZbrane() {
  $("aside").remove();

  if (KF.enable) {
    //---vytvoreni divu
    var $div = KF.createDiv("dvKf");
    //$div.appendTo('main#content  article');
    $div.appendTo("main#content");

    //---vypis selectrou pro sestaveni zbrane
    KF.vypisVolby();
    //---nacte konfiguraci z url adresy a uloži ji do Local storage
    KF.loadConfigFromUrl();
  }
} //function  upravStrankuKonfiguraceZbrane()
